// extracted by mini-css-extract-plugin
export default {"training":"VuMkk","diff":"MEkkm"};